import anime from 'animejs'

import {Component} from 'lowkey-component'
import {MediaQuery} from '@services/MediaQuery'
import {WindowService} from '@services/WindowService'

const phoneRatio = 0.43
const minWidth = 86

export class Symbol extends Component<HTMLDivElement> {

  private mq = MediaQuery.create()
  private window = WindowService.create()
  private loading: HTMLDivElement | undefined
  private logo: HTMLDivElement | undefined
  private str: HTMLDivElement | undefined
  private copy: HTMLDivElement | undefined
  private backdrop: HTMLDivElement | undefined
  private inner: HTMLDivElement | undefined

  // didMountのタイミングでは、selectSiteIndicatorPercentが発火しないのでconstructorで
  constructor(element: HTMLDivElement) {
    super(element)
    this.onResize = this.onResize.bind(this)
    this.logo = this.element.querySelector('.m-symbol_logo_logo') as HTMLDivElement
    this.str = this.element.querySelector('.m-symbol_logo_str') as HTMLDivElement
    this.copy = this.element.querySelector('.m-symbol_logo_copy') as HTMLDivElement
    this.loading = this.element.querySelector('.m-symbol_loading') as HTMLDivElement
    this.backdrop = this.element.querySelector('.m-symbol_backdrop') as HTMLDivElement
    this.inner = this.element.querySelector('.m-symbol_inner') as HTMLDivElement
  }

  didMount() {
    setTimeout(() => {
      this.start()
    }, 2500)

    this.window.onResize.connect(this.onResize)

    this.onResize()
  }

  didUnmount() {
    this.window.onResize.disconnect(this.onResize)
  }

  onResize() {
    if (this.inner) {
      this.inner.style.transform = 'scale(1.0)'
      const {height = 0} = this.str?.getBoundingClientRect() || {}
      this.inner.style.transform = `scale(${phoneRatio})`
      if (this.loading) {
        this.loading.style.height = `${height}px`
      }
    }
  }

  start() {
    const tl = anime.timeline({
      loop: true,
    })
    tl.add({
      duration: 500,
      targets: this.loading,
      easing: 'easeOutExpo',
      opacity: [0, 1],
    })
    tl.add({
      duration: 500,
      targets: this.loading,
      easing: 'easeOutExpo',
      width: () => [minWidth, this.getStrWidth()],
    })
    tl.add({
      targets: [this.logo, this.str, this.copy],
      duration: 1000,
      opacity: [0, 1],
      easing: 'easeOutCirc',
    }, '-=100')
    tl.add({
      targets: this.loading,
      duration: 1000,
      opacity: [1, 0],
      easing: 'easeOutCirc',
    }, '-=1100')
    tl.add({
      duration: 1300,
      targets: this.logo,
      translateY: [-15, 0],
      easing: 'easeOutQuart',
    }, '-=1100')
    tl.add({
      duration: 1300,
      targets: this.copy,
      translateY: [15, 0],
      easing: 'easeOutQuart',
    }, '-=1400')
    tl.add({
      targets: this.backdrop,
      duration: 1000,
      translateY: [0, '-100%'],
      easing: 'easeInOutCubic',
    }, '-=800')
    tl.add({
      targets: this.inner,
      duration: 800,
      opacity: 0,
      easing: 'easeOutCubic',
    }, '-=500')

    if (this.inner) {
      if (this.mq.isPhone()) {
        this.inner.style.transform = `scale(${phoneRatio})`
      } else {
        this.inner.style.transform = 'scale(1.0)'
      }
    }
  }

  getStrWidth() {
    if (this.inner) {
      this.inner.style.transform = 'scale(1.0)'
      const {width} = this.str?.getBoundingClientRect() || {}
      this.inner.style.transform = `scale(${phoneRatio})`
      return width
    }
  }

}
